import {SVGProps} from 'react';

const Icon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        fill="none"
        height="24"
        viewBox="0 0 24 24"
        width="24"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            clipRule="evenodd"
            d="M5.25 5.5C5.25 4.25736 6.25736 3.25 7.5 3.25H11.75V8C11.75 9.24264 12.7574 10.25 14 10.25H18.75V11C18.75 11.4142 19.0858 11.75 19.5 11.75C19.9142 11.75 20.25 11.4142 20.25 11V9.5V9.12132C20.25 8.52458 20.0129 7.95229 19.591 7.53033L14.4697 2.40901C14.0477 1.98705 13.4754 1.75 12.8787 1.75H12.5H7.5C5.42893 1.75 3.75 3.42893 3.75 5.5V18.5C3.75 20.5711 5.42893 22.25 7.5 22.25H11.5C11.9142 22.25 12.25 21.9142 12.25 21.5C12.25 21.0858 11.9142 20.75 11.5 20.75H7.5C6.25736 20.75 5.25 19.7426 5.25 18.5V5.5ZM13.25 8V3.34837C13.3077 3.38124 13.3612 3.4219 13.409 3.46967L18.5303 8.59099C18.5781 8.63876 18.6188 8.69231 18.6516 8.75H14C13.5858 8.75 13.25 8.41421 13.25 8ZM17.5 14.25C15.7051 14.25 14.25 15.7051 14.25 17.5C14.25 18.1257 14.4268 18.7102 14.7333 19.2061L19.2061 14.7333C18.7102 14.4268 18.1257 14.25 17.5 14.25ZM17.5 20.75C16.8743 20.75 16.2898 20.5732 15.7939 20.2667L20.2667 15.7939C20.5732 16.2898 20.75 16.8743 20.75 17.5C20.75 19.2949 19.2949 20.75 17.5 20.75ZM12.75 17.5C12.75 14.8766 14.8766 12.75 17.5 12.75C20.1234 12.75 22.25 14.8766 22.25 17.5C22.25 20.1234 20.1234 22.25 17.5 22.25C14.8766 22.25 12.75 20.1234 12.75 17.5Z"
            fill="currentColor"
            fillRule="evenodd"
        />
    </svg>
);

export default Icon;
